import { favoritesApi } from './api/favoritesApi';

export interface FavoriteEvent {
  id: string;
  title: string;
  description: string;
  date: string;
  time: string;
  venue: string;
  category: string;
  price: number;
  capacity: number;
  image: string;
  status: string;
  tags: string[];
  sections?: any[];
  createdAt: string;
}

class FavoritesService {
  // Get all user favorites
  async getFavorites(): Promise<FavoriteEvent[]> {
    try {
      const response = await favoritesApi.getFavorites();
      if (response && response.data && response.data.favorites) {
        return response.data.favorites.map((fav: any) => fav.event);
      }
      return [];
    } catch (error: any) {
      console.error('Error fetching favorites:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch favorites');
    }
  }

  // Add event to favorites
  async addFavorite(eventId: string): Promise<void> {
    try {
      await favoritesApi.addFavorite(eventId);
    } catch (error: any) {
      console.error('Error adding favorite:', error);
      throw new Error(error.response?.data?.message || 'Failed to add favorite');
    }
  }

  // Remove event from favorites
  async removeFavorite(eventId: string): Promise<void> {
    try {
      await favoritesApi.removeFavorite(eventId);
    } catch (error: any) {
      console.error('Error removing favorite:', error);
      throw new Error(error.response?.data?.message || 'Failed to remove favorite');
    }
  }

  // Check if event is favorited
  async isFavorited(eventId: string): Promise<boolean> {
    try {
      const response = await favoritesApi.checkFavorite(eventId);
      return response?.data?.isFavorited || false;
    } catch (error: any) {
      console.error('Error checking favorite status:', error);
      return false;
    }
  }

  // Toggle favorite status
  async toggleFavorite(eventId: string, isCurrentlyFavorited: boolean): Promise<boolean> {
    try {
      if (isCurrentlyFavorited) {
        await this.removeFavorite(eventId);
        return false;
      } else {
        await this.addFavorite(eventId);
        return true;
      }
    } catch (error: any) {
      console.error('Error toggling favorite:', error);
      throw error;
    }
  }
}

export const favoritesService = new FavoritesService();




